export default __webpack_public_path__ + "static/media/community.00950993.svg";